import { type FC, useEffect, useRef } from 'react';

import { ENV } from '@/common/app/env';

import css from './styles.module.scss';

const TelegramLoginButton: FC = () => {
  const ref = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://telegram.org/js/telegram-widget.js?22';
    scriptElement.setAttribute('data-telegram-login', ENV.TELEGRAM_BOT_NAME);
    scriptElement.setAttribute('data-size', 'large');
    scriptElement.setAttribute('data-min-height', '48');

    const urlParams = new URLSearchParams(window.location.search);
    const startParam = urlParams.get('start_param');
    const callbackUrl = startParam
      ? `${ENV.API_BACKEND_URL}/auth/telegram/callback?start_param=${encodeURIComponent(startParam)}`
      : `${ENV.API_BACKEND_URL}/auth/telegram/callback`;
    scriptElement.setAttribute('data-auth-url', callbackUrl);
    scriptElement.setAttribute('data-request-access', 'write');
    scriptElement.async = true;

    ref.current?.appendChild(scriptElement);

    return (): void => {
      ref.current?.removeChild(scriptElement);
    };
  }, []);

  return <div ref={ref} className={css.telegramLoginWrapper}></div>;
};

export { TelegramLoginButton };
